// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
// ** Axios Imports
import axios from 'axios'
import {useDispatch} from "react-redux";
import {useParams} from "react-router-dom";

export const setLoading = createAsyncThunk('ItemConsumption/setLoading', async (loadingState) => ({ ...loadingState }))

export const getData = createAsyncThunk('ItemConsumption/getData', async (params, { dispatch }) => {
  dispatch(setLoading({ getData: true }))
  const response = await axios.get('/InventoryConsumption/List', { params })
  dispatch(setLoading({ getData: false }))
  return {
    params,
    data: response.data,
  }
})

export const getTypeData = createAsyncThunk('ItemConsumption/getTypeData', async () => {
  const dispatch = useDispatch()
  const params= useParams()
  dispatch(setLoading({ getTypeData: true }))
  const response = await axios.get('/InventoryConsumption/List', { params })
  dispatch(setLoading({ getTypeData: false }))
  return {
    params,
    typeData: response.data
  }
})

export const ItemConsumptionSlice = createSlice({
  name: 'ItemConsumption',
  initialState: {
    data: [],
    totalRecords: 1,
    typeData: [],
    totalTypeRecords: 1,
    params: {},
    typeParams: {},
    loadingState: { getData: false, getTypeData: false, getJournal: false }
    // allData: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.fulfilled, (state, action) => {

        state.data = action.payload.data.data.list
        state.totalRecords = action.payload.data.totalRecords
        state.params = action.payload.params
      })
      .addCase(getTypeData.fulfilled, (state, action) => {
        state.typeData = action.payload.data.data.list
        state.totalTypeRecords = action.payload.data.totalRecords
        state.typeParams = action.payload.params
      })
      .addCase(setLoading.fulfilled, (state, action) => {
        state.loadingState = action.payload
      })
  }
})

export default ItemConsumptionSlice.reducer
